<template>
  <div
    v-if="
      props.model &&
      ((props.model.url && isValidSrc) ||
        (props.model.base64 && props.model.base64.length > 0) ||
        (props.model.path && isValidSrc))
    "
  >
    <img
      v-if="props.model.path && props.model.path.length > 0"
      :src="baseUrl + model?.path!"
      :alt="props.alt"
      :key="componentKey"
      class="icon"
    />
    <img
      v-if="props.model.url && props.model.url.length > 0"
      :src="model?.url!"
      :alt="props.alt"
      :key="componentKey"
      class="icon"
    />
    <img
      v-if="props.model.base64 && props.model.base64.length > 0"
      :src="model?.base64!"
      :alt="props.alt"
      :key="componentKey"
      class="icon"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { isImageExtensionValid } from '../composables/Validation'
import type { Icon } from '../types/configuration/Icon'
import { updateComponentKey } from '../composables/ComponentKey'

const props = defineProps<{
  model: Icon | undefined
  alt?: string | undefined
}>()

const isValidSrc = ref(false)
const baseUrl = import.meta.env.VITE_BASE_URL

let componentKey = updateComponentKey(
  props,
  () =>
    (isValidSrc.value =
      props.model !== undefined &&
      ((props.model.url !== undefined &&
        props.model.url !== null &&
        props.model.url.length > 0 &&
        isImageExtensionValid(props.model.url)) ||
        (props.model.path !== undefined &&
          props.model.path !== null &&
          props.model.path.length > 0 &&
          isImageExtensionValid(props.model.path))))
)
</script>

<style scoped lang="scss">
.icon {
  width: inherit;
}
</style>
